import { AfterViewChecked, Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { AdvertisementPageIds } from '@planone/bau365/data-access-fair-data';
import { DataAccessScreensizeFacade } from '@planone/bau365/data-access-screensize';
import { DocumentRef, WindowRef } from '@planone/shared/util-browser-api';
import { BehaviorSubject, Observable, takeUntil } from 'rxjs';

import { AdvertisementComponent } from '../advertisement.component';
import { SAS_SCRIPTS_LOADED, SAS_SCRIPTS_LOADING } from '../advertisement.helper';

@Component({
  selector: 'bau365-skyscraper-advertisement',
  templateUrl: './skyscraper-advertisement.component.html',
})
export class SkyscraperAdvertisementComponent
  extends AdvertisementComponent
  implements OnInit, AfterViewChecked, OnDestroy
{
  @Input() siteId?: number = 554984;
  @Input() pageIds?: AdvertisementPageIds = {
    de: 1691643,
    en: 1691644,
  };
  @Input() format?: number = 24905;

  size$: Observable<string | undefined>;

  constructor(
    private screensizeFacade: DataAccessScreensizeFacade,
    private renderer2: Renderer2,
    private document: DocumentRef,
    private window: WindowRef,
    private activatedRoute: ActivatedRoute,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(SAS_SCRIPTS_LOADED) private sasScriptsLoaded: BehaviorSubject<boolean>,
    @Inject(SAS_SCRIPTS_LOADING) private sasScriptsLoading: BehaviorSubject<boolean>
  ) {
    super(document, renderer2, sasScriptsLoaded, sasScriptsLoading, window, screensizeFacade);

    this.size$ = screensizeFacade.size$;
    this.locale = this.localeId.split('-')[0] ?? 'de';
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.render(true));
  }

  ngAfterViewChecked() {
    this.render();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  desktopAd() {
    if (!this.sasScriptsLoaded.getValue()) {
      this.initialize();
    }

    if (this.locale === 'de') {
      this.window.nativeWindow.sas.cmd.push(() => {
        this.window.nativeWindow.sas.call('onecall', {
          siteId: this.siteId,
          pageId: this.pageIds?.de,
          formats: [{ id: this.format }],
          target: '',
        });
      });
    } else if (this.locale === 'en') {
      this.window.nativeWindow.sas.cmd.push(() => {
        this.window.nativeWindow.sas.call('onecall', {
          siteId: this.siteId,
          pageId: this.pageIds?.en,
          formats: [{ id: this.format }],
          target: '',
        });
      });
    }

    /**
     * Render smart ad server phone advertisements
     */
    this.window.nativeWindow.sas.cmd.push(() => {
      this.window.nativeWindow.sas.render(this.format);
    });
  }

  render(force = false) {
    const type = this.size === 'phone' ? this.size : 'desktop';

    if (!this.rendered.includes(type) || force) {
      const containerId = 'sas_' + this.format;

      if (this.document.nativeDocument.getElementById(containerId)) {
        const action = (size?: string) => {
          if (size !== 'phone') {
            this.desktopAd();
          }
        };

        this.insert(action);

        this.rendered.push(type);
      } else {
        const index = this.rendered.indexOf(type);

        this.rendered.splice(index, 1);
      }
    }
  }
}
